// extracted by mini-css-extract-plugin
export default {"tableCell":"table-cell_tableCell__vm+4n","actions":"table-cell_actions__pbky1"};